<template>
  <tr
    style="height: 75px"
    class="clickable"
    @click="$emit('view:yacht-equipment-pack', yachtEquipmentPack)"
  >
    <td
      :style="{ borderLeft: `5px solid ${yachtEquipmentPack.category ? yachtEquipmentPack.category.color : 'transparent'}`}"
      style="padding-left: 11px; padding-right: 2px"
    >
      <v-simple-checkbox
        :value="isSelected"
        class="show-on-hover"
        :class="{ 'visible': isSelected }"
        color="primary"
        :ripple="false"
        @input="select"
      />
    </td>
    <td
      style="min-width: 460px; max-width: 460px; width: 460px; padding-left: 0"
    >
      <div>
        <div class="text-truncate font-weight-bold body-2">
          {{ yachtEquipmentPack.label }}
        </div>
        <div class="caption grey--text lighten-1 text-truncate">
          <v-icon
            v-if="yachtEquipmentPack.offer_visible"
            small
            color="blue lighten-2"
            class="mr-2"
          >
            visibility
          </v-icon>
          <v-icon
            v-else
            small
            color="grey lighten-1"
            class="mr-2"
          >
            visibility_off
          </v-icon>
          <flag
            v-for="country in countries"
            :key="country.id"
            :iso="country.code"
            :squared="false"
            class="radius-3 mr-1 elevation-5"
            :style="[ ...!country.included && { opacity: 0.2, filter: 'grayscale(100%)' } ]"
          />
        </div>
      </div>
    </td>
    <td
      class="grey--text px-0"
      style="min-width: 130px; max-width: 130px; width: 130px"
    >
      {{ yachtEquipmentPack.installed_by ? installedByData[yachtEquipmentPack.installed_by].label : '' }}
    </td>
    <td
      style="min-width: 170px; max-width: 170px; width: 170px"
      class="text-truncate"
    >
      <div v-if="yachtEquipmentPack.models_count > 1">
        <strong>{{ yachtEquipmentPack.models_count }}</strong> models
      </div>
      <div
        v-else-if="yachtEquipmentPack.first_model"
        class="text-truncate"
      >
        {{ yachtEquipmentPack.first_model.label }}
        <div class="font-weight-light grey--text text--darken-2">
          {{ yachtEquipmentPack.first_model.manufacturer.name }}
        </div>
      </div>
    </td>
    <td style="min-width: 140px; max-width: 140px; width: 140px">
      <span v-if="yachtEquipmentPack.category">
        {{ yachtEquipmentPack.category.name }}
      </span>
      <span
        v-else
        class="grey--text text--lighten-1"
      >
        n/a
      </span>
    </td>
    <td>
      {{ yachtEquipmentPack.updated_at | moment('D MMM YYYY HH:mm') }}
    </td>
    <td class="text-right primary--text pr-0">
      {{ yachtEquipmentPack.currency }}
      <strong class="ml-1">
        {{ yachtEquipmentPack.sale_price | currency('') }}
      </strong>
    </td>
    <td
      style="width: 1%"
      class="px-1"
    >
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
          >
            <v-icon small>
              more_vert
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click="$emit('edit:yacht-equipment-pack', yachtEquipmentPack)"
          >
            <v-list-item-title>
              <v-icon
                small
                class="mr-2"
              >
                edit
              </v-icon>
              Edit
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="$emit('copy:yacht-equipment-pack', yachtEquipmentPack)"
          >
            <v-list-item-title>
              <v-icon
                small
                class="mr-2"
              >
                file_copy
              </v-icon>
              Copy
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>
  </tr>
</template>

<script>
import YachtEquipmentPackModel from '@/models/YachtEquipmentPack'
import { sortBy } from 'lodash'

export default {
    name: 'YachtEquipmentPackRow',
    props: {
      yachtEquipmentPack: {
        type: Object,
        default: () => {
        }
      },
      isSelected: {
        type: Boolean
      },
      select: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        installedByData: YachtEquipmentPackModel.installedByData
      }
    },
    computed: {
      items() {
        return this.yachtEquipmentPack.items.slice(0, 5).map(i => i.label).join(', ')
      },
      itemsRemaining() {
        let totalItems = this.yachtEquipmentPack.items.length

        if (totalItems <= 6) return 0

        return totalItems - 5
      },
      countries() {
        return sortBy(this.$store.getters['settings/charteringCountriesAllOrganisations'].data, 'name').map(c => {
          return {
            ...c,
            included: this.yachtEquipmentPack.countries.some(pc => c.id === pc.id)
          }
        })
      },
      yachtModels() {
        let totalItems = this.yachtEquipmentPack.models.length

        return this.yachtEquipmentPack.models.slice(0, totalItems > 8 ? 7 : 8)
      },
      yachtModelsRemaining() {
        let totalItems = this.yachtEquipmentPack.models.length

        if (totalItems <= 8) return 0

        return totalItems - 7
      }
    }
  }
</script>
